import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);

  const navLinks = [
    { 
      label: 'Home', 
      href: '/',
      hasDropdown: true,
      subLinks: [
        { label: 'The Polymathy', href: '/polymathy' },
        { label: 'Partners & Sponsors', href: '/affiliates' }
      ]
    },
    { 
      label: 'Services', 
      href: '/services',
      hasDropdown: true,
      subLinks: [
        { label: 'Governance, Risk & Compliance (GRC)', href: '/services/grc' },
        { label: 'Financial Services', href: '/services/financial' },
        { label: 'Workforce Solutions', href: '/services/workforce' }
      ]
    },
    { 
      label: 'Our Team', 
      href: '/home',
      hasDropdown: true,
      subLinks: [
        { label: 'About Us', href: '/about' },
        { label: 'Portfolio', href: '/portfolio' },
        { label: 'Professional Organizations & Certifications', href: '/certifications' }
      ]
    },
    { label: 'Contact Us', href: '/contact' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Toggle body scroll
    if (!isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setOpenDropdownIndex(null);
    document.body.classList.remove('mobile-menu-open');
  };

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, []);

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          {/* Logo / Brand */}
          <Link to="/media" className="nav-logo" onClick={closeMobileMenu}>
            <span className="logo-text">The Polymath</span>
          </Link>

          {/* Desktop Navigation Links */}
          <ul className="nav-links desktop-nav">
            {navLinks.map((link, index) => (
              <li key={index} className={link.hasDropdown ? 'has-dropdown' : ''}>
                {link.hasDropdown ? (
                  <div className="dropdown">
                    <Link to={link.href} className="nav-link">
                      {link.label}
                      <i className="fas fa-chevron-down"></i>
                    </Link>
                    <div className="dropdown-menu">
                      {link.subLinks.map((subLink, subIndex) => (
                        <Link key={subIndex} to={subLink.href} className="dropdown-item">
                          {subLink.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link to={link.href} className="nav-link">
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>

          {/* Mobile Hamburger Menu */}
          <button 
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <ul className="mobile-nav-links">
          {navLinks.map((link, index) => (
            <li key={index}>
              {link.hasDropdown ? (
                <>
                  <div className="mobile-nav-item-with-dropdown">
                    <Link 
                      to={link.href} 
                      className="mobile-nav-link"
                      onClick={closeMobileMenu}
                    >
                      {link.label}
                    </Link>
                    <button
                      className="mobile-dropdown-toggle-btn"
                      onClick={() => toggleDropdown(index)}
                      aria-label={`Toggle ${link.label} submenu`}
                    >
                      <i className={`fas fa-chevron-${openDropdownIndex === index ? 'up' : 'down'}`}></i>
                    </button>
                  </div>
                  {openDropdownIndex === index && (
                    <div className="mobile-dropdown">
                      {link.subLinks.map((subLink, subIndex) => (
                        <Link 
                          key={subIndex}
                          to={subLink.href} 
                          className="mobile-dropdown-link"
                          onClick={closeMobileMenu}
                        >
                          {subLink.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <Link 
                  to={link.href} 
                  className="mobile-nav-link"
                  onClick={closeMobileMenu}
                >
                  {link.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
    </nav>
  );
};

export default Navigation;

